// extracted by mini-css-extract-plugin
export default {"tile":"testTile_tile__Aps58","tileChild":"testTile_tileChild__KzhVS","name":"testTile_name__ZZFnQ","admin":"testTile_admin__PeqRT"};